(function ($) {
  $(function () {

    /*****
      Fancybox
      ---
      This is just sample code, to be extended
    *****/
    $().fancybox({
      selector: '.video-lightbox, .photo-lightbox',
      hash: false,
      buttons: ['close'],
      infobar: false,
      idleTime: 300,
      loop: true,
      btnTpl: {
        close:
          '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' + return_svg('close') + '</button>',
        arrowLeft:
          '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
          return_svg('scroll_arrow') +
          "</button>",
        arrowRight:
          '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
          return_svg('scroll_arrow') +
          "</button>",
      },
      beforeShow: function () {
        $('.fancybox-content .lightbox-custom-caption').remove();
      },
      afterShow: function (instance, slide) {
        var fancyfeatured = instance.current.opts.fancyfeatured || false;
        var fancytitle = instance.current.opts.fancytitle || false;
        var fancysubtitle = instance.current.opts.fancysubtitle || false;
        var fancycaption = instance.current.opts.fancycaption || false;
        var fancydownloadtitle = instance.current.opts.fancydownloadtitle || false;
        var fancydownloadurl = instance.current.opts.fancydownloadurl || false;

        if (fancyfeatured || fancytitle || fancysubtitle || fancycaption || fancydownloadtitle || fancydownloadurl) {
          $('.fancybox-content').append('<div class="lightbox-custom-caption"></div>');

          if (fancyfeatured) {
            $('.lightbox-custom-caption').append('<p class="lightbox-featured video-item-featured-label">' + fancyfeatured + '</p>');
          }

          if (fancytitle) {
            $('.lightbox-custom-caption').append('<h3 class="lightbox-title video-item-title">' + fancytitle + '</h3>');
          }

          if (fancysubtitle) {
            $('.lightbox-custom-caption').append('<p class="lightbox-subtitle video-item-caption">' + fancysubtitle + '</p>');
          }

          if (fancycaption) {
            $('.lightbox-custom-caption').append('<p class="lightbox-caption video-item-subtitle">' + fancycaption + '</p>');
          }

          if (fancydownloadtitle || fancydownloadurl) {
            $('.lightbox-custom-caption').append('<p class="lightbox-download"><a class="button-light" target="_blank" href="' + fancydownloadurl + '">' + fancydownloadtitle + '</a></p>');
          }
        }
      }
    });

  });
})(jQuery);
